import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, numberFilter, Comparator } from 'react-bootstrap-table2-filter';
import ToolkitProvider, { CSVExport, ColumnToggle } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import paginationFactory, { PaginationProvider, PaginationTotalStandalone, PaginationListStandalone } from 'react-bootstrap-table2-paginator';
// import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'; 

const MyExportCSV = (props) => {
  const handleClick = () => {
    props.onExport();
  };
  return (
    <div className="col-md-4 center">
      <button className="btn btn-success" onClick={ handleClick }>Export Visible Data To File</button>
    </div>
  );
};
const { ToggleList } = ColumnToggle;
const columns = [{
  dataField: 'index',
  text: 'Index',
  sort: true
},
{
  dataField: 'image',
  text: 'Image',
  formatter: imageFormatter
},
{
  dataField: 'id',
  text: 'Id',
  hidden: true
}, 
{
  dataField: 'campaignType',
  text: 'Type',
  sort: true,
  filter: textFilter()
}, 
{
  dataField: 'activeInLastValue',
  text: 'Active In Last',
  sort: true,
  hidden: true
}, 
{
  dataField: 'inactiveInLastValue',
  text: 'Inactive In Last',
  sort: true,
  hidden: true
}, 
{
  dataField: 'spentLessThanValue',
  text: 'Spent Less Than',
  sort: true,
  hidden: true
}, 
{
  dataField: 'spentMoreThanValue',
  text: 'Spent More Than',
  sort: true,
  hidden: true
}, 
{
  dataField: 'visitedLessThanValue',
  text: 'Visited Less Than',
  sort: true,
  hidden: true
}, 
{
  dataField: 'visitedMoreThanValue',
  text: 'Visited More Than',
  sort: true,
  hidden: true
}, 
{
  dataField: 'city',
  text: 'City',
  sort: true,
  filter: textFilter(),
  hidden: true
}, 
{
  dataField: 'storeId',
  text: 'Store Id',
  sort: true,
  filter: textFilter(),
  hidden: true
}, 
{
  dataField: 'offerValue',
  text: 'Offer',
  sort: true
},
{
  dataField: 'numberOfUserToTarget',
  text: 'Targeted',
  sort: true
},
{
  dataField: 'likes',
  text: 'Likes',
  sort: true,
  hidden: true,
  formatter: arrayFormatter
},
{
  dataField: 'dislikes',
  text: 'Dislikes',
  sort: true,
  hidden: true,
  formatter: arrayFormatter
},
{
  dataField: 'date',
  text: 'Date'
},
// {
//   dataField: 'time',
//   text: 'Time'
// }, 
// {
//   dataField: 'timestamp',
//   text: 'Timestamp',
//   sort: true
// }
];

function imageFormatter(cell, row){
  return (<img style={{width:100}} src={cell}/>)
}

function arrayFormatter(cell, row) {
  var size = 0;
  if (cell) {
    size = cell.split(",").length
  }
  return (<p> <b>Count: {size}</b> <br/> {cell}</p>)
}

export const Campaigns = ({campaigns}) => {
    const rowEvents = {
      onClick: (e, row, rowIndex) => {
        // alert("Row index: " + (rowIndex + 1));
      }
    };

    const options = {
      sizePerPageList: [{ text: '50', value: 50 }, { text: '100', value: 100 }, { text: '250', value: 250 }, {text: 'All', value: campaigns.length}],
      showTotal: true
    }
    
    return (
        <ToolkitProvider
          keyField='index' 
          data={ campaigns } 
          columns={ columns }
          columnToggle
          pagination={ paginationFactory(options) }
          exportCSV={ {
            exportAll: false
          } }>
          { props => (
            <div>
              <hr/>
                <MyExportCSV { ...props.csvProps }/>
              <hr />
                <ToggleList { ...props.columnToggleProps } />
              <hr />
              <BootstrapTable striped bordered hover { ...props.baseProps } 
                pagination={ paginationFactory(options) }
                rowEvents={ rowEvents } 
                bootstrap4={ true }
                tabIndexCell
                filter={ filterFactory() }
              />
            </div>
          )
          }
          </ToolkitProvider>
    )
}